module.exports = __webpack_public_path__ + "static/media/magazine-luiza.10f7ce10.svg";